// extracted by css-extract-rspack-plugin
export default {"popover":"NOrNTNinVcbvYghG"};